module.exports = __webpack_public_path__ + "img/coast-rock-fm.6cc00c16.png";